var styles = {"row":"Row_row_1agok_1"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
